var loadjs_umd = {exports: {}};

export { loadjs_umd as __module };
